import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {

  constructor(
    private title: Title
  ) {
    this.title.setTitle('Tarifs - Office notarial Pacé');
  }

  ngOnInit(): void {
  }

}
